import { render, staticRenderFns } from "./clicks-card.vue?vue&type=template&id=2a90fdcd&scoped=true&"
import script from "./clicks-card.vue?vue&type=script&lang=js&"
export * from "./clicks-card.vue?vue&type=script&lang=js&"
import style0 from "./clicks-card.vue?vue&type=style&index=0&id=2a90fdcd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a90fdcd",
  null
  
)

export default component.exports